export default __webpack_public_path__ + "static/media/Rachel_Esterline_Perkins_AHV_In_Moms_We_Trust.dc6bcaf3.jpg";